import { SyncLoader } from 'react-spinners';
import { BRAND_LOADER_COLOR } from 'utils/constants';

interface PortalSpinnerProps {
  size?: number;
  /** Tailwind padding class applied to the wrapper. Defaults to py-16. */
  padding?: string;
}

export const PortalSpinner = ({ size = 8, padding = 'py-16' }: PortalSpinnerProps) => (
  <div className={`flex items-center justify-center ${padding}`}>
    <SyncLoader color={BRAND_LOADER_COLOR} size={size} />
  </div>
);
